export class UserModel {
  constructor(public Id: string,
              public TitleId: string,
              public FirstName: string,
              public LastName: string,
              public SureName: string,
              public Email: string,
              public EmailDomainId: string,
              public RegistrationNumber: string,
              public RoleId: string) {
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/user/user.model.ts